import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Procedures, TestPanelManager, TestDefinitionManager } from '../components/Procedures';
import LabIntegration from '../components/Procedures/LabIntegration';
import Results from '../components/Procedures/Results';
import OrderStatus from '../components/Procedures/OrderStatus';
import LabReportsDemo from '../components/LabReports/LabReportsDemo';

export const procedureRoutes = (
  <Routes>
    <Route path="/" element={<Procedures />} />
    <Route path="/test-panels" element={<TestPanelManager />} />
    <Route path="/test-definitions" element={<TestDefinitionManager />} />
    <Route path="/lab-integration" element={<LabIntegration />} />
    <Route path="/results" element={<Results />} />
    <Route path="/order-status" element={<OrderStatus />} />
    <Route path="/lab-reports-demo" element={<LabReportsDemo />} />
  </Routes>
); 